import { Button, Checkbox, TextField, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "../../../../../components/Dialog";
import { isBlank } from "./debtorBlock";

interface Props {
  open: boolean;
  count: number;
  clientName: string;
  pending: boolean;
  error: string;
  onCancel: () => void;
  onConfirm: (reason: string, appliesToFuture: boolean) => void;
}

const effectRow = { display: "flex", gap: 8 } as React.CSSProperties;

const BlockAllDialog = ({
  open,
  count,
  clientName,
  pending,
  error,
  onCancel,
  onConfirm
}: Props): JSX.Element => {
  const [reason, setReason] = useState("");
  const [appliesToFuture, setAppliesToFuture] = useState(true);

  useEffect(() => {
    if (open) {
      setReason("");
      setAppliesToFuture(true);
    }
  }, [open]);

  const reasonBlank = isBlank(reason);

  return (
    <Dialog open={open} fullWidth maxWidth="sm" onClose={onCancel}>
      <DialogTitle onClose={onCancel}>Block factoring on all debtors?</DialogTitle>
      <DialogContent>
        <Typography paragraph>
          This turns on <strong>Block</strong> for all <strong>{count}</strong> debtors
          connected to <strong>{clientName}</strong>.
        </Typography>
        <Typography
          component="div"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 6,
            padding: "10px 12px",
            background: "#f5f7fa",
            borderRadius: 4,
            fontSize: 13,
            color: "#424242"
          }}
        >
          <div style={effectRow}>
            <span style={{ color: "#c62828", fontWeight: 700 }}>✕</span>
            New factored (Standard) funding requests are rejected
          </div>
          <div style={effectRow}>
            <span style={{ color: "#c62828", fontWeight: 700 }}>✕</span>
            Existing factored funding requests can’t be approved
          </div>
          <div style={effectRow}>
            <span style={{ color: "#2e7d32", fontWeight: 700 }}>✓</span>
            Non-factored and self-finance invoices are still allowed
          </div>
        </Typography>
        <Typography component="label" style={{ display: "flex", alignItems: "flex-start", marginTop: 12, fontSize: 13 }}>
          <Checkbox
            checked={appliesToFuture}
            onChange={(event): void => setAppliesToFuture(event.target.checked)}
            color="primary"
            style={{ padding: "0 10px 0 0" }}
            inputProps={{ "aria-label": "Also block debtors connected later" }}
          />
          <span>
            <strong>Also block debtors connected later</strong>
            <br />
            <span style={{ color: "#616161" }}>
              Otherwise a debtor this client adds tomorrow can still be factored.
            </span>
          </span>
        </Typography>
        <TextField
          label="Reason (required, shown when unblocking and saved to the audit log)"
          placeholder="e.g. Carrier lost insurance"
          value={reason}
          onChange={(event): void => setReason(event.target.value)}
          error={reasonBlank}
          helperText={reasonBlank ? "Enter a reason to block these debtors." : " "}
          required
          fullWidth
          margin="normal"
          inputProps={{ "aria-label": "Reason" }}
        />
        {error && (
          <Typography color="error" role="alert">
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onCancel} disabled={pending}>
          Cancel
        </Button>
        <Button
          variant="contained"
          style={
            reasonBlank || pending
              ? undefined
              : { backgroundColor: "#c62828", color: "#fff" }
          }
          disabled={reasonBlank || pending}
          onClick={(): void => onConfirm(reason.trim(), appliesToFuture)}
        >
          {pending ? "Blocking..." : `Block ${count} debtors`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BlockAllDialog;
